// import components
import {
  showErrorSnackbar,
  showSuccessSnackbar
} from 'components/shared/Snackbar';

// import hooks
import { useMutation, useQueryClient } from 'react-query';

// import queries & mutations
import { removeEmployeeNote } from 'RestAPIs/employees/notes';

// import types
import { RemoveEmployeeNoteParams } from './useRemoveEmployeeNotes.types';

const useRemoveEmployeeNote = () => {
  const queryClient = useQueryClient();

  return useMutation(
    (params: RemoveEmployeeNoteParams) => removeEmployeeNote(params),
    {
      onSuccess: (_data, { type }: { type: string }) => {
        queryClient.invalidateQueries(
          type === 'employeeNote' ? 'employeeNotes' : 'hoursTable'
        );
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};

export default useRemoveEmployeeNote;
